import React from "react";
import { useTranslation } from "react-i18next";

function Touch() {
  const [t] = useTranslation();
  return (
    <>
      <section id="services" className="services-area pt-120 pb-90 fix">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="section-title text-center mb-50 wow fadeInDown animated"
                data-animation="fadeInDown"
                data-delay=".4s"
              >
                <h5>
                  <i className="fas fa-graduation-cap" />{" "}
                  {t("kontakt.titleCap")}
                </h5>
                <h2>{t("kontakt.titleMain")}</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div className="services-box text-center">
                <div className="services-icon">
                  <img
                    src="assets/img/bg/contact-icon01.png"
                    alt="contact-icon"
                  />
                </div>
                <div className="services-content2">
                  <h5>
                    <a href="tel:+382 (0) 68/003-113">+382 (0) 68/003-113</a>
                  </h5>
                  <p>{t("kontakt.broj")}</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="services-box text-center active">
                <div className="services-icon">
                  <img src="assets/img/bg/contact-icon02.png" alt="mail-icon" />
                </div>
                <div className="services-content2">
                  <h5>
                    <a href="mailto:fpebar@gmail.com">fpebar@gmail.com</a>
                  </h5>
                  <p>{t("kontakt.email")}</p>
                </div>
                <div className="services-content2 pt-20">
                  <h5>
                    <a href="mailto:international@fpebar.me">
                      international@fpebar.me
                    </a>
                  </h5>
                  <p>{t("kontakt.email")}</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="services-box text-center">
                <div className="services-icon">
                  <img
                    src="assets/img/bg/contact-icon03.png"
                    alt="location-icon"
                  />
                </div>
                <div className="services-content2">
                  <h5>16 Rista Lekića, Bar</h5>
                  <p>{t("kontakt.lokacija")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Touch;
